
import React from 'react';
import { Loader2 } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { useIPAccess } from '@/hooks/useIPAccess';
import GameNotFound from '@/components/game-detail/GameNotFound';

interface IPAccessGuardProps {
  children: React.ReactNode;
}

const IPAccessGuard: React.FC<IPAccessGuardProps> = ({ children }) => {
  const { ipAccess, loading } = useIPAccess();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-red-900 to-slate-900 flex items-center justify-center p-4">
        <Card className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl border border-white/20 p-8 text-center max-w-md">
          <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
          </div>
          <h1 className="text-xl font-bold text-gray-900 mb-2">Loading</h1>
          <p className="text-gray-600 text-sm">Please wait...</p>
        </Card>
      </div>
    );
  }

  if (!ipAccess?.allowed) {
    return <GameNotFound />;
  }

  return <>{children}</>;
};

export default IPAccessGuard;
